export const QA = 'QA';
export const STATUS_FILTER = {
  onHold: 'ON HOLD',
  awaitingAudit: 'AWAITING AUDIT',
  inProgress: 'IN PROGRESS',
  inReview: 'IN REVIEW',
  awaitingReview: 'AWAITING REVIEW',
  archived: 'ARCHIVED',
  awaitingAssignment: 'AWAITING ASSIGNMENT',
  clientRebuttal: 'CLIENT REBUTTAL',
  rebuttalInProgress: 'REBUTTAL IN PROGRESS',
};
export const NEW_UPLOAD = ['AWAITING REVIEW'];
export const ARCHIVED = 'ARCHIVED';
export const REBBUTTAL = ['CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'];
export const MY_AUDITS = [
  'AWAITING REVIEW',
  'IN REVIEW',
  'ON HOLD',
];
export const SELF = 'self';
export const URGENT = [
  'AWAITING REVIEW',
  'IN REVIEW',
  'ON HOLD',
  'CLIENT REBUTTAL',
  'REBUTTAL IN PROGRESS',
];
export const getAuditStatus = props => {
  switch (props) {
    case 'ON HOLD':
      return 'On Hold';
    case 'AWAITING AUDIT':
      return 'Awaiting Audit';
    case 'IN PROGRESS':
      return 'In Progress';
    case 'IN REVIEW':
      return 'In Review';
    case 'AWAITING REVIEW':
      return 'Awaiting Review';
    case 'ARCHIVED':
      return 'Archived';
    case 'AWAITING ASSIGNMENT':
      return 'Awaiting Assignment';
    case 'CLIENT REBUTTAL':
      return 'Client Rebuttal';
    case 'REBUTTAL IN PROGRESS':
      return 'Rebuttal In Progress';
    default:
      return 'N/A';
  }
};
export const SIZE = 10;
export const AWAITING_AUDIT = 'AWAITING AUDIT';
export const MY_AUDITS_ORDERING = [
  'chart_id',
  'upload_date',
  'client',
  'specialty__name',
  'total_pages',
  'status',
  'updated_date',
  'auditor',
  'qa',
  'audited_date',
  '-chart_id',
  '-upload_date',
  '-client',
  '-specialty__name',
  '-total_pages',
  '-status',
  '-updated_date',
  '-auditor',
  '-qa',
  '-audited_date',
];
export const REQUIRED_FIELDS = [
  'encounter_no',
  'rendering',
  'enc_dt',

  'srvcs_no',

  'provider_rvu',
  'provider_dollar_value',

  // 'response',
  'agree',
  'disagree',

  'audited_cpt',
  
  'audited_rvu',
  'audited_dollar_value',
  'notes',
  'response',
];
export const ROLES_VALUES = {
  QA: 'QA',
  AUDITOR: 'Auditor',
  MANAGER: 'Manager',
  CLIENT: 'Client',
};

export const FILE_TYPE = {
  CLIENT: "CLIENT",
  AUDIT: "AUDIT",
  ADDITIONAL: "ADDITIONAL"
}


export const FILTER_OPTIONS = [
    'All',
    // 'New Uploads',
    'In Audit',
    'In QA',
    'Archived',
    'Rebuttals',
    'On Hold',
    'Reviewed',
    // 'Urgent'
  ];

export const FILTER_OPTIONS_TO_CHART_STATUS_MAP = {
    'ALL': [],
    'New Uploads': 'AWAITING REVIEW',
    'In QA': ['AWAITING REVIEW', 'IN REVIEW', 'CLIENT REBUTTAL'],
    'Reviewed': ['ARCHIVED', 'CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'],
    'In Audit': 'IN PROGRESS',
    'Archived': 'ARCHIVED',
    'Rebuttals': ['CLIENT REBUTTAL', 'REBUTTAL IN PROGRESS'],
    'On Hold': "ON HOLD",
    "Urgent": 'URGENT'
  }  

export const ChartFilterInfo = [
  {
    name: "All",
    definition: "All the batches that have been assigned to you.",
  },
  {
    name: "In Audit",
    definition: "Batches which are currently being audited.",
  },
  {
    name:'In QA',
    definition: 'Batches which have been submitted by auditor and is in qa.'
  },
  {
    name:'Archived',
    definition: 'Batches which have been completed.'
  },
  {
    name: 'Rebuttal',
    definition: "Batches which are currently in rebuttal"
  },
  {
    name: 'On Hold',
    definition: 'Batches which are on hold'
  },
  {
    name: "Reviewed",
    definition: 'Batches which has already been reviewed by the qa in the past. Could be at any stage post qa. '
  }
];